export default "__VITE_ASSET___S2kqEwC__"